export default "__VITE_ASSET__r2YPZ4t0__"